import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HomeshoppingDataService } from 'src/app/services/homeshopping-data.service';
import { NotificationService } from 'src/app/services/notification-service';
import * as _ from "lodash";


@Component({
  selector: 'app-shopping-configuration',
  templateUrl: './shopping-configuration.component.html',
  styleUrls: ['./shopping-configuration.component.scss']
})
export class ShoppingConfigurationComponent implements OnInit {
    data = [];
    dataSource = new MatTableDataSource(this.data);
    displayedColumns: string[] = [
      "productname",
      "popular",
      "newarrival",
      "saleitems",
      "outofstock",
    ];

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    form: FormGroup;
    shoppingProductList: any;
    dataExcel: any[];
  constructor(private fb:FormBuilder,private homeshoppingDataService:HomeshoppingDataService,private toast:NotificationService) { }

  ngOnInit() {
    // this.initializeValidators()
    this.getTableData('')
  }
//   initializeValidators() {
//     this.form = this.fb.group({
//         isPopular: [false,],
//         isNewArrival: [false ],
//         isSaleItems: [false],
//         saleCost: [null,],
//         isOutOfStock: [false,],
//     });
// }
submitShoppingConfiguration () {

    this.homeshoppingDataService.saveShopConfiguration(this.dataSource.filteredData).subscribe( (result) =>{
        if (result) {
           this.toast.showSuccess("Product Configured successfully")
           this.getTableData('')
        }
    });
}

getTableData(data) {
    if (data) {
      data = { SearchQuery: data }
    }
    this.homeshoppingDataService.getShoppingProductsForConfiguration().subscribe((result) => {
      this.data = [];
      this.dataExcel = [];
      this.data = result;
      this.dataExcel = result;
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  check(flag,data){
    if(flag=='pop'){
      data.isNewArrival=false
      data.isSaleItems=false
    }
    if(flag=='new'){
      data.isPopular=false
      data.isSaleItems=false
    }
    if(flag=='sales'){
      data.isNewArrival=false
      data.isPopular=false
    }

  }
}
